import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";
import { Delete, Visibility } from "@mui/icons-material";
import httpClient from  "../Api/axios";



const ApplicationFormReport = () => {
  const [missions, setMissions] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [currentMission, setCurrentMission] = useState(null);
  const [deleteId, setDeleteId] = useState(null);

  useEffect(() => {
    fetchMissions();
  }, []);

  const fetchMissions = async () => {
    try {
      const response = await httpClient.get('/api/ApplicationFormMaster/getAll');
      setMissions(response.data); 
      console.log(response.data);
    } catch (error) {
      console.error("Error fetching applications:", error);
    }
  };

  const handleView = (mission) => {
    setCurrentMission(mission);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setCurrentMission(null);
  };

  const handleDelete = (id) => {
    setDeleteId(id);
    setOpenDeleteDialog(true);
  };

  const confirmDelete = async () => {
    try {
      await httpClient.delete(`/api/ApplicationFormMaster/delete/${deleteId}`);
      setMissions(missions.filter((m) => m.id !== deleteId));
      setOpenDeleteDialog(false);
    } catch (error) {
      console.error("Error deleting application:", error);
    }
  };

  return (
    <div className="p-8">
      <TableContainer component={Paper} className="mt-4">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Address</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>DOB</TableCell>
              <TableCell>Mobile no</TableCell>
              <TableCell>College Name</TableCell>
              <TableCell>Degree</TableCell>
              <TableCell>Academic Year</TableCell>
              <TableCell>Selected Course</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {missions.map((mission) => (
              <TableRow key={mission.id}>
                <TableCell>{mission.id}</TableCell>
                <TableCell>{mission.name}</TableCell>
                <TableCell>{mission.address}</TableCell>
                <TableCell>{mission.email}</TableCell>
                <TableCell>{mission.dob}</TableCell>
                <TableCell>{mission.mobileNo}</TableCell>
                <TableCell>{mission.collegeName}</TableCell>
                <TableCell>{mission.degree}</TableCell>
                <TableCell>{mission.academicYear}</TableCell>
                <TableCell>{mission.selectedCourse}</TableCell>
                <TableCell>
                <Button onClick={() => handleView(mission)}>
                    <Visibility color="primary" />
                  </Button>
                  <Button onClick={() => handleDelete(mission.id)}>
                    <Delete color="error" />
                  </Button>
                  
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* View Dialog */}
      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>Student Details</DialogTitle>
        <DialogContent>
          {currentMission && (
            <div className="p-4 space-y-2">
              <p><strong>ID:</strong> {currentMission.id}</p>
              <p><strong>Name:</strong> {currentMission.name}</p>
              <p><strong>Address:</strong> {currentMission.address}</p>
              <p><strong>Email:</strong> {currentMission.email}</p>
              <p><strong>Date of Birth:</strong> {currentMission.dob}</p>
              <p><strong>Mobile:</strong> {currentMission.mobileNo}</p>
              <p><strong>College:</strong> {currentMission.collegeName}</p>
              <p><strong>Degree:</strong> {currentMission.degree}</p>
              <p><strong>Academic Year:</strong> {currentMission.academicYear}</p>
              <p><strong>Selected Course:</strong> {currentMission.selectedCourse}</p>
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* Delete Confirmation Dialog */}
      <Dialog open={openDeleteDialog} onClose={() => setOpenDeleteDialog(false)}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>Are you sure you want to delete this entry?</DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDeleteDialog(false)}>Cancel</Button>
          <Button onClick={confirmDelete} color="error" variant="contained">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ApplicationFormReport;
